export const ATTRIBUTES_DISPLAY_NAME = [
  'email',
  'display_name',
  'username',
  'first_name',
  'last_name',
  'principal_name',
  'distinguished_name',
  'common_name',
  'organization',
  'country',
  'organization_unit',
  'city',
  'state',
  'zip_code',
  'address',
  'phone',
  'fax',
  'mobile',
  'title',
]; // After adding the new attribute, you need to add it to the translations.
